export const colors = {
  primary: "#FF7722",
  secondary: "#22AAFF",
  yellow: "#FFB800",
  black: "#0000",
  light: "#ffff",
  green: "#40AE40",
  red: "#DC3545",
  orange: "#FF9900",
};
